import React from 'react';
const BurgerIcon = (props) => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "#6E6764", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { id: "view-column" },
        React.createElement("path", { id: "Vector", d: "M16 5V18H21V5M4 18H9V5H4M10 18H15V5H10V18Z" }))));
export default BurgerIcon;
